import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import jwtDecode from "jwt-decode";
import { MenuAccess } from "../utils/menuOptions";

const useAuth = () => {
	const token = useSelector((state: RootState) => state.auth)?.token;
	const menuOptions: MenuAccess[] | null = useMemo(() => {
		if (!token) {
			return null;
		}
		let decodedJwt: any;
		try {
			decodedJwt = jwtDecode(token);
		} catch (error) {
			return null;
		}
		if (!decodedJwt?.MenuOptions) {
			return null;
		}
		const menuOptions = decodedJwt.MenuOptions.split(",");
		return menuOptions;
	}, [token]);

	return {
		token,
		isLoggedIn: !!token,
		menuOptions,
	};
};

export default useAuth;
